{
  "meta": {
    "fetchedAt": "2026-05-04T08:10:44.636Z",
    "categories": [
      {
        "id": "necessary",
        "label": "Strictly necessary"
      },
      {
        "id": "performances",
        "label": "Performances"
      },
      {
        "id": "advertising",
        "label": "Advertising"
      },
      {
        "id": "unknown",
        "label": "Uncategorised"
      }
    ]
  },
  "cookies": [
    {
      "name": "__cf_bm",
      "domain": ".hubspot.com",
      "category": "necessary",
      "duration": "30 minutes"
    },
    {
      "name": "__cf_bm",
      "domain": ".malt.fr",
      "category": "necessary",
      "duration": "30 minutes"
    },
    {
      "name": "__hssc",
      "domain": ".malt.fr",
      "category": "performances",
      "duration": "30 minutes"
    },
    {
      "name": "__hssrc",
      "domain": ".malt.fr",
      "category": "performances",
      "duration": "session"
    },
    {
      "name": "__hstc",
      "domain": ".malt.fr",
      "category": "performances",
      "duration": "6 months"
    },
    {
      "name": "__Secure-ROLLOUT_TOKEN",
      "domain": ".youtube.com",
      "category": "advertising",
      "duration": "6 months"
    },
    {
      "name": "__Secure-YNID",
      "domain": ".youtube.com",
      "category": "advertising",
      "duration": "6 months"
    },
    {
      "name": "_cfuvid",
      "domain": ".hubspot.com",
      "category": "necessary",
      "duration": "session"
    },
    {
      "name": "_fbp",
      "domain": ".malt.fr",
      "category": "performances",
      "duration": "3 months"
    },
    {
      "name": "_gcl_au",
      "domain": ".malt.fr",
      "category": "performances",
      "duration": "3 months"
    },
    {
      "name": "axeptio_all_vendors",
      "domain": "www.malt.fr",
      "category": "necessary",
      "duration": "12 months"
    },
    {
      "name": "axeptio_authorized_vendors",
      "domain": "www.malt.fr",
      "category": "necessary",
      "duration": "12 months"
    },
    {
      "name": "axeptio_cookies",
      "domain": "www.malt.fr",
      "category": "necessary",
      "duration": "12 months"
    },
    {
      "name": "bcookie",
      "domain": ".linkedin.com",
      "category": "advertising",
      "duration": "12 months"
    },
    {
      "name": "cf_clearance",
      "domain": ".malt.fr",
      "category": "necessary",
      "duration": "12 months"
    },
    {
      "name": "hubspotutk",
      "domain": ".malt.fr",
      "category": "performances",
      "duration": "6 months"
    },
    {
      "name": "i18n",
      "domain": "www.malt.fr",
      "category": "necessary",
      "duration": "session"
    },
    {
      "name": "IDE",
      "domain": ".doubleclick.net",
      "category": "advertising",
      "duration": "1 year"
    },
    {
      "name": "JSESSIONID",
      "domain": "www.malt.fr",
      "category": "necessary",
      "duration": "session"
    },
    {
      "name": "li_gc",
      "domain": ".linkedin.com",
      "category": "advertising",
      "duration": "6 months"
    },
    {
      "name": "lidc",
      "domain": ".linkedin.com",
      "category": "advertising",
      "duration": "24 hours"
    },
    {
      "name": "malt-visitorId",
      "domain": "www.malt.fr",
      "category": "necessary",
      "duration": "2 months"
    },
    {
      "name": "SESSION",
      "domain": "www.malt.fr",
      "category": "necessary",
      "duration": "session"
    },
    {
      "name": "VISITOR_INFO1_LIVE",
      "domain": ".youtube.com",
      "category": "advertising",
      "duration": "6 months"
    },
    {
      "name": "VISITOR_PRIVACY_METADATA",
      "domain": ".youtube.com",
      "category": "advertising",
      "duration": "6 months"
    },
    {
      "name": "XSRF-TOKEN",
      "domain": "www.malt.fr",
      "category": "necessary",
      "duration": "session"
    },
    {
      "name": "YSC",
      "domain": ".youtube.com",
      "category": "advertising",
      "duration": "session"
    }
  ]
}
